import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// Fixed film-grain + a soft spotlight cursor that trails the mouse.
export const NoiseCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const mx = useMotionValue(-200);
  const my = useMotionValue(-200);
  const x = useSpring(mx, { stiffness: 350, damping: 30, mass: 0.4 });
  const y = useSpring(my, { stiffness: 350, damping: 30, mass: 0.4 });

  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) setEnabled(true);
    const move = (e) => {
      mx.set(e.clientX);
      my.set(e.clientY);
      const t = e.target;
      setHovering(!!(t && t.closest && t.closest("[data-cursor='art']")));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [mx, my]);

  return (
    <>
      <div className="bds-noise" aria-hidden />
      {enabled && (
        <motion.div
          aria-hidden
          className="fixed top-0 left-0 z-[55] pointer-events-none rounded-full"
          style={{
            x,
            y,
            translateX: "-50%",
            translateY: "-50%",
            width: hovering ? 320 : 26,
            height: hovering ? 320 : 26,
            background: hovering
              ? "radial-gradient(circle, rgba(139,58,43,0.22) 0%, rgba(139,58,43,0) 70%)"
              : "radial-gradient(circle, rgba(247,245,240,0.55) 0%, rgba(247,245,240,0) 70%)",
            transition: "width 0.35s ease, height 0.35s ease, background 0.35s ease",
            mixBlendMode: hovering ? "screen" : "difference",
          }}
        />
      )}
    </>
  );
};
